(ns frontend.view.nev.kyc.process.multi-select-checkbox-editor
  (:require
   [common.schema.entities.workspace.kyc.kyc-utils :as ku]
   [ui.components.input.checkbox :as checkbox]
   [ui.util :as uu]))

(defn editor [{:keys [process-id lang-kw question-attribute question-meta answers-atom mandatory? read-only? save!] :as _args}]
  (let [value (set (get @answers-atom question-attribute))
        info (get-in question-meta [:info lang-kw])
        info-position (:info-position question-meta)
        info-below-label? (and info (= info-position :below-label))]
    [:div
     {:class "flex flex-col"}
     [:label
      {:class (uu/cm "input-editor__label pb-2 shrink-0"
                     (when mandatory?
                       "after:ml-0.5 after:text-danger-regular after:content-['*']")
                     (when info-below-label?
                       "pb-2"))}
      (some-> question-meta
              :translations
              (get lang-kw))]

     (when info-below-label?
       [:p
        {:class "pb-2 text-sm m-0"}
        info])

     [:ul
      {:class "space-y-3"}
      (->> (ku/active-options (:options question-meta) value)
           (map (fn [option]
                  (let [option-key (:key option)
                        input-id (str process-id "-" question-attribute "-" option-key)
                        selected? (boolean (some #{option-key} value))
                        disabled? (or read-only? (:disabled? option))]
                    [:li
                     {:key input-id}
                     [:label
                      {:for input-id
                       :class (uu/cm "flex"
                                     (when-not disabled?
                                       "cursor-pointer")
                                     (when (:disabled? option)
                                       "opacity-50"))}
                      [:div
                       {:class "mr-2 mt-[2.5px]"}
                       [checkbox/view
                        {:id input-id
                         :value selected?
                         :on-change (fn [_e]
                                      (when-not disabled?
                                        (if selected?
                                          (swap! answers-atom assoc question-attribute (disj value option-key))
                                          (swap! answers-atom assoc question-attribute (conj value option-key)))
                                        (deref answers-atom)
                                        (save!)))
                         :disabled? disabled?}]]

                      (ku/localize option [] lang-kw)]])))
           (doall))]]))
